import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { isAuthed, loading, user } = useAuth();
  const loc = useLocation();

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    </div>
  );

  if (!isAuthed) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;

  if (roles && !roles.includes(user?.role)) return <Navigate to="/portal" replace />;

  return children;
}
